import Typography, { type TypographyProps } from "@mui/material/Typography";

/**
 * The centered, muted heading shown above a loading sequence
 * (e.g. on the Fetching / Analysing interstitials). Renders as an `<h1>`.
 */
export function LoadingTitle(props: TypographyProps) {
  return (
    <Typography variant="h6" component="h1" color="text.secondary" textAlign="center" {...props} />
  );
}
